import BugReport from 'components/BugReport'
import Loading from 'components/common/loading/Loading'
import LanguageSwitcher from 'components/language/LanguageSelector'
import { useAuth } from 'pages/authenticated/AuthContext'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { NavigationItemType } from 'types/navigation'

import AppLogo from './AppLogo'

type MobileNavbarProps = {
  navigationItems: NavigationItemType[] | undefined
  isOpen: boolean
  onClose: () => void
}

const MobileNavBar = ({ navigationItems, isOpen, onClose }: MobileNavbarProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const { isAuthenticated } = useAuth()

  if (!navigationItems) return <Loading />

  const handleNavigation = (path: string) => {
    navigate(path)
    onClose()
  }

  const handleAuthNavigation = (path: '/auth' | '/create-user') => {
    navigate(path, {
      state: { from: location },
    })
    onClose()
  }

  if (!isOpen) return null

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black bg-opacity-50"
        onClick={onClose}
      />
      <div className="fixed left-0 right-0 top-0 z-50 origin-top transform animate-in border-b border-gray-100 bg-imovWhite shadow-lg transition-all duration-300 ease-out slide-in-from-top-2">
        <div className="mb-4 flex items-center px-4 py-2">
          <AppLogo variant="light" iconHeight="h-10" />
        </div>
        <div className="px-4 py-4 pb-6">
          <div className="space-y-1">
            <div className="[&_button]:rounded-lg [&_button]:text-imovSecondary [&_button]:hover:bg-gray-100">
              <BugReport mobile />
            </div>
            {navigationItems.map((item, index) => (
              <button
                key={index}
                onClick={() => handleNavigation(item.navigate)}
                className={`flex w-full items-center space-x-3 rounded-lg px-4 py-3 text-left text-sm font-medium transition-all duration-200 ${
                  location.pathname === item.navigate
                    ? 'bg-imovPrimary/10 text-imovPrimary'
                    : 'text-imovSecondary hover:bg-gray-100'
                }`}
              >
                <span>{t(item.label || '')}</span>
              </button>
            ))}
            {!isAuthenticated ? (
              <>
                <button
                  onClick={() => handleAuthNavigation('/auth')}
                  className={`flex w-full items-center space-x-3 rounded-lg px-4 py-3 text-left text-sm font-medium transition-all duration-200 ${
                    location.pathname === '/auth'
                      ? 'bg-imovPrimary/10 text-imovPrimary'
                      : 'text-imovSecondary hover:bg-gray-100'
                  }`}
                >
                  <span>{t('common.logIn')}</span>
                </button>
                <button
                  onClick={() => handleAuthNavigation('/create-user')}
                  className="flex w-full items-center justify-center rounded-lg bg-imovPrimary px-4 py-3 text-sm font-semibold text-imovWhite transition-colors hover:bg-imovPrimaryDark"
                >
                  {t('home.start')}
                </button>
                <div className="flex w-full items-center justify-end pt-2">
                  <LanguageSwitcher />
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default MobileNavBar
